module.exports = __webpack_public_path__ + "static/media/SAP Screenshot.5b0f10ed.svg";